import styled from 'styled-components'

export const Container = styled.div`
  margin-top: 2rem;
  width: 100%;
`

export const Form = styled.form`
  display: flex;
  flex-direction: column;
  gap: 2rem;
  width: 100%;
  margin-top: 1rem;

  > p {
    color: #898989;
    margin: 10px 0;
  }

  > button {
    height: 48px;
    width: 100%;
    margin-bottom: 3rem;
    border-radius: 50px;
    border: none;
    background: #1F35B5;
    color: #FFFFFF;
    transition: background 0.3s;
    display: flex;
    align-items: center;
    justify-content: center;

    &:hover {
      background: #3650E5;
    }

    > div {
      width: 30px;
      height: 30px;
      border-width: 3px;
      border-color: #fff;
      border-top-color: transparent !important;
    }
  }
`